import { lazy } from 'react';
import MainLayout from 'Layouts/Main/Main';

const PatientRegistry = lazy(() => import('Containers/EMR/PatientRegistry/PatientRegistry'));
const PatientDetails = lazy(() => import('Containers/EMR/PatientDetails/PatientDetails'));
const VisitDetails = lazy(() => import('Containers/EMR/VisitDetails/VisitDetails'));

const routes = [
  {
    path: '/emr',
    exact: true,
    ContentComponent: PatientRegistry,
    Layout: MainLayout,
  },
  {
    path: '/emr/:clinicId',
    exact: true,
    ContentComponent: PatientRegistry,
    Layout: MainLayout,
  },
  {
    path: '/emr/:clinicId/:nric',
    exact: true,
    ContentComponent: PatientDetails,
    Layout: MainLayout,
  },
  {
    path: '/emr/:clinicId/:nric/:visitId',
    exact: true,
    ContentComponent: VisitDetails,
    Layout: MainLayout,
  },
];

export default routes;
